import { forwardRef, PropsWithChildren } from "react";
import { Checkbox } from "@mantine/core";

export interface ICheckboxProps {
  id?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  name?: string;
  size?: string;
  value: string;
  onChange: () => void;
  error?: string;
}

const StyledCheckbox = forwardRef<
  HTMLInputElement,
  PropsWithChildren<ICheckboxProps>
>(({ label, size = "md", error, value, onChange }, ref) => {
  return (
    <Checkbox
      checked={value}
      ref={ref}
      label={label}
      size={size}
      error={error}
      onChange={event => onChange(event.currentTarget.checked)}
      mt="md"
    />
  );
});

export default StyledCheckbox;
